import { Component, OnInit } from '@angular/core';
import { SmoochService } from 'src/app/services/smooch.service';
import { ConnectService } from 'src/app/services/connect.service';
import { AuthenticatedContext } from 'src/app/models/authenticated-context';
import { Channel } from 'src/app/models/channel';
import { Observable, BehaviorSubject } from 'rxjs';
import { DEFAULT_MESSENGER_CHANNEL, DEFAULT_TWITTER_CHANNEL } from './default-channels';
import { MatSnackBar } from '@angular/material/snack-bar';

type SupportedChannel = {
  connector: string;
  channel: Channel;
}

@Component({
  selector: 'app-integrations',
  templateUrl: './integrations.component.html',
  styleUrls: ['./integrations.component.scss']
})
export class IntegrationsComponent implements OnInit {

  supportedChannels: SupportedChannel[] = [
    { connector: 'facebook', channel: DEFAULT_MESSENGER_CHANNEL },
    { connector: 'twitter', channel: DEFAULT_TWITTER_CHANNEL }
  ];

  defaultChannels: Channel[] = [
    DEFAULT_MESSENGER_CHANNEL, DEFAULT_TWITTER_CHANNEL
  ]

  private _context$: BehaviorSubject<AuthenticatedContext> = new BehaviorSubject<AuthenticatedContext>(null);
  get context$(): Observable<AuthenticatedContext> {
    return this._context$.asObservable();
  }

  constructor(
    private _smoochService: SmoochService,
    private _connectService: ConnectService,
    private _snackBar: MatSnackBar
  ) {
    this.initChannels(this._smoochService);
  }

  private initChannels(smoochService: SmoochService) {
    smoochService.integrations$.subscribe(integratedChannels => {
      for (let supportedChannel of this.supportedChannels) {
        supportedChannel.channel = integratedChannels.find(integration => integration.type === supportedChannel.channel.type)
          || this.defaultChannels.find(channel => channel.type === supportedChannel.channel.type);
      }
    });
  }

  ngOnInit() {
  }

  authorize(channel: SupportedChannel) {
    let subscription = this._connectService.authorize(channel.connector)
      .subscribe(context => {
        this._context$.next(context);
        subscription.unsubscribe();
      }, error => {
        console.error(error);
      });
  }

  copied(): void {
    this._snackBar.open(`Copied to clipboard.`);
  }

}
